import React, { useEffect, useState } from 'react';
import { Box, Theme, Typography } from '@mui/material';
import { Feature } from '@loyalty/shared-common';
import {
  IdentityAttributes,
  ProfileAttributes,
  ProfileIdentityKind,
} from '@loyalty/shared-common/profile-api-client';
import { makeStyles } from '@mui/styles';
import { useApi } from '../../../shared/api-client/ApiClientProvider';
import { useFeatures } from '../../../features/FeaturesContext';
import { useProgram } from '../../../loyalty/ProgramContext';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  list: {
    margin: 0,
    padding: 0,
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: spacing(1, 0),
  },
  property: {
    fontWeight: '600 !important',
    width: '40%',
  },
  value: {
    width: '60%',
    marginLeft: '5px',
  },
  picture: {
    height: 108,
    marginLeft: spacing(-3),
    width: 108,
  },
}));

export function ProfileDetailsIdentitiesList({
  profile,
}: {
  profile: ProfileAttributes;
}): React.ReactElement {
  const classes = useStyles();
  const { programId } = useProgram();
  const { profileApi } = useApi();
  const [identities, setIdentities] = useState<IdentityAttributes[]>([]);
  const { features } = useFeatures();
  const { enabled: seeKcId } = features[Feature.SEE_KC_ID];
  const fetchIdentities = async (profileId: string) => {
    profileApi
      .getProfileIdentities(profileId)
      .then(idents =>
        setIdentities(
          idents.filter(
            identity => identity.programId === null || identity.programId === programId,
          ),
        ),
      )
      .catch(() => setIdentities([]));
  };

  useEffect(() => {
    fetchIdentities(profile.id).catch(console.error);
  }, [profile]);

  const shownIdentities = seeKcId
    ? identities
    : identities.filter(identity => identity.kind !== ProfileIdentityKind.keycloakId);

  return (
    <ul className={classes.list}>
      {shownIdentities
        .sort((a, b) => a.kind.localeCompare(b.kind))
        .map(identity => (
          <Box key={identity.id} component="li" className={classes.listItem}>
            <Typography variant="body1" component="div" className={classes.property}>
              {identity.kind}
            </Typography>
            <Typography variant="body1" component="div" className={classes.value}>
              {identity.value ?? '-'}
            </Typography>
          </Box>
        ))}
    </ul>
  );
}
